__turbopack_context__.v({
  "ad1": "VyXcdW_ad1",
  "ad2": "VyXcdW_ad2",
  "ads": "VyXcdW_ads",
  "ads_diamensions": "VyXcdW_ads_diamensions",
  "arrow": "VyXcdW_arrow",
  "authorName": "VyXcdW_authorName",
  "author_by": "VyXcdW_author_by",
  "category": "VyXcdW_category",
  "checkedStory": "VyXcdW_checkedStory",
  "post-title": "VyXcdW_post-title",
  "post__info": "VyXcdW_post__info",
  "posthomepage__featuredArticle": "VyXcdW_posthomepage__featuredArticle",
  "posthomepage__featuredArticles": "VyXcdW_posthomepage__featuredArticles",
  "posthomepage__featuredArticles__section": "VyXcdW_posthomepage__featuredArticles__section",
  "posthomepage__recentStories": "VyXcdW_posthomepage__recentStories",
  "posthomepage__recentStories__section": "VyXcdW_posthomepage__recentStories__section",
  "posthomepage__recentStory": "VyXcdW_posthomepage__recentStory",
  "posthomepage__stories": "VyXcdW_posthomepage__stories",
  "posthomepage__top__stories": "VyXcdW_posthomepage__top__stories",
  "posthomepage__top__story": "VyXcdW_posthomepage__top__story",
  "posthomepage__trendingStories": "VyXcdW_posthomepage__trendingStories",
  "posthomepage__trendingStories__section": "VyXcdW_posthomepage__trendingStories__section",
  "posthomepage__trendingStory": "VyXcdW_posthomepage__trendingStory",
  "promoted": "VyXcdW_promoted",
  "recentStories": "VyXcdW_recentStories",
  "right": "VyXcdW_right",
  "sub-title": "VyXcdW_sub-title",
  "topStories": "VyXcdW_topStories",
  "trendingStories": "VyXcdW_trendingStories",
  "trendingstories__readnow__button": "VyXcdW_trendingstories__readnow__button",
  "trendingstories__readnow__text": "VyXcdW_trendingstories__readnow__text",
});
